import { render, staticRenderFns } from "./student-journey-tree-view.vue?vue&type=template&id=c6b7229e&"
import script from "./student-journey-tree-view.ts?vue&type=script&lang=ts&"
export * from "./student-journey-tree-view.ts?vue&type=script&lang=ts&"
import style0 from "./student-journey-tree-view.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports